/**
 * PinBoxes — 4 dot/box indicators showing how many digits entered.
 *
 * Per doc 08 §10.1:
 *  - 4 boxes, one per digit
 *  - Filled = purple #563F7A
 *  - Empty = light border #E5E5E5
 *  - 60x60 minimum touch target
 *  - a11y: "Digit ke-N dari 4, [terisi|kosong]"
 *
 * The component is presentational — parent owns the `length` state.
 */

import { StyleSheet, View } from 'react-native';

import { Brand, Radii } from '@/constants/theme';

interface PinBoxesProps {
  length: number;
  total?: number;
}

export function PinBoxes({ length, total = 4 }: PinBoxesProps) {
  return (
    <View style={styles.container}>
      {Array.from({ length: total }).map((_, i) => {
        const filled = i < length;
        return (
          <View
            key={i}
            style={[styles.box, filled ? styles.boxFilled : styles.boxEmpty]}
            accessibilityRole="text"
            accessibilityLabel={
              filled
                ? `Digit ke-${i + 1} dari ${total}, terisi`
                : `Digit ke-${i + 1} dari ${total}, kosong`
            }
          />
        );
      })}
    </View>
  );
}

const BOX_SIZE = 56;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 12,
    justifyContent: 'center',
  },
  box: {
    width: BOX_SIZE,
    height: BOX_SIZE,
    borderRadius: Radii.medium,
    borderWidth: 2,
  },
  boxEmpty: {
    backgroundColor: '#ffffff',
    borderColor: '#e5e5e5',
  },
  boxFilled: {
    backgroundColor: Brand.primary,
    borderColor: Brand.primary,
  },
});
